import React, { useContext } from 'react'
import { ASGTabBackground, ASVoteCon } from '../../styles'
import { Desc, Head } from '../../../../Components/Typography/Text.styles'
import { Img } from '../../../../Components/Image/Img'
import { ALL_STAR_IMAGES } from '../../consts'
import { colors } from '../../../../Components/consts'
import { LinkBtn } from '../../../../Components/Buttons/LinkBtn'
import { ALL_STAR_VOTING_URL } from '../../../../Routing/urls'
import { AllStarContext } from '../../../../Context'

export const Voting: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { closed } = useContext(AllStarContext)!
  const analytics = {
    event: 'all_star_vote_click',
    params: {
      location: 'all_star_game_page',
      btnText: 'Vote Now',
    },
  }
  return (
    <ASGTabBackground>
      <ASVoteCon>
        <Img src={ALL_STAR_IMAGES.votingLogo} alt="All star voting logo" />
        <Head
          justify="center"
          textColor={colors.white}
          vertMargins={4}
        >{`Vote for your favorite players to make the All Star game!`}</Head>
        {!closed && (
          <LinkBtn href={ALL_STAR_VOTING_URL} btnStyle="primary" analytics={analytics} aria-label="Vote Now">
            <Desc textColor={colors.text}>Vote Now</Desc>
          </LinkBtn>
        )}
        {closed && (
          <Desc
            justify="center"
            textColor={colors.gray.gray40}
            vertMargins={8}
          >{`2024 Voting has closed.`}</Desc>
        )}
      </ASVoteCon>
    </ASGTabBackground>
  )
}
